<template>
    <div>
        <el-table
            style="width: 100%"
            :data="data"
            :max-height="params.attr.maxHeight ? params.attr.maxHeight : '500'"
            v-bind="params.attr.attr"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            v-loading="loading"
        >
            <el-table-column header-align="center" align="center" v-if="params.attr && params.attr.selection" type="selection" width="55"></el-table-column>
            <el-table-column header-align="center" align="center" v-if="params.attr && params.attr.index" type="index" label="序号"></el-table-column>
            <template v-for="(item, index) in params.fields">
                <el-table-column
                    v-if="item.type && item.type==='switch'"
                    :label="item.label"
                    :min-width="item.minWidth"
                    :width="item.width"
                    v-bind="item.attr"
                     header-align="center"
                     align="center"
                    :key="index">
                    <template slot-scope="scope">
                        <!-- :disabled="!$route.meta.power.run" -->
                        <el-switch
                            @change="switchChange(scope)"
                            v-model="scope.row[item.value]"
                            v-bind="item.switch"
                        ></el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else-if="item.type && item.type==='custom'"
                    :label="item.label"
                    :min-width="item.minWidth"
                    :width="item.width"
                    v-bind="item.attr"
                    header-align="center"
                    align="center"
                    :key="index">
                    <template slot-scope="scope">
                        <slot :name="item.value" :item="item" :row="scope.row" :index="scope.$index" />
                    </template>
                </el-table-column>
                <template v-else-if="item.type && item.type ==='customAll'">
                    <slot :name="item.value" />
                </template>
                <el-table-column
                    v-else
                    :label="item.label"
                    :key="index"
                    :prop="item.value"
                    :min-width="item.minWidth"
                    :width="item.width"
                    v-bind="item.attr"
                    header-align="center"
                    align="center"
                ></el-table-column>
            </template>
            <el-table-column label="操作" align="center" v-if="params.attr ? !params.attr.btnHidden : true"
                     :width="params.attr ? params.attr.btnWidth : ''"
                     :min-width="params.attr ? params.attr.btnMinWidth : ''">
                <template slot-scope="scope">
                    <template v-if="params.tableBtns && params.tableBtns.length > 0">
                      <template v-for="(item, index) in params.tableBtns">
                        <wt-auth class="search-form-btn" v-bind:key="index" :hasAnyPremission="!item.permission ? '' : form.formCode + ':' + item.permission">
                          <el-button size="mini"
                                     :type="item.className ? item.className : 'default'" @click="actionClick(scope.row, item)"
                          >{{ item.condition ? item.value[scope.row[item.condition]] : item.name}}</el-button>
                        </wt-auth>
                      </template>
                    </template>
                    <slot name="tableListButtonsAfter" :row="scope.row" :index="scope.$index" />
                </template>
            </el-table-column>
        </el-table>
        <page-component
            v-if="params.attr && params.attr.page"
            :total="params.pageData.total"
            :currentPage="params.pageData.pageIndex"
            :pageSize="params.pageData.pageSize"
            @currentPageChange="handleCurrentPage"
            @pageSizeChange="handlePageSize"
        />
    </div>
</template>
<script>
export default {
  name: 'normal-table',
  props: ['params', 'data'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    // 复选框选中数据
    handleSelectionChange(data) {
      console.log(this.data)
      this.params.selectedList = data
    },
    // 排序
    handleSortChange(column) {
      console.log(column)
    },
    // 当前分页改变
    handleCurrentPage(pageIndex) {
      this.params.pageData.pageIndex = pageIndex
      this.$emit('on-button-action', { action: 'PAGEINDEX' }, pageIndex)
    },
    // 当分页条数改变
    handlePageSize(pageSize) {
      this.params.pageData.pageSize = pageSize
      this.params.pageData.pageIndex = 1
      this.$emit('on-button-action', { action: 'PAGESIZE' }, pageSize)
    },
    // 状态开关
    switchChange(row) {
      this.$emit('on-button-action', { action: 'SWITCH' }, row)
    },
    actionClick(actionClass, params) {
      this.$emit('on-button-action', { action: actionClass }, params)
    },
    // loading 控制
    openLoading() {
      this.loading = true
    },
    closeLoading() {
      this.loading = false
    }
  }
}
</script>
